
const dadosBoxesPainelAlarmes = (painelAlarmes) => {
  return [
    {
      name: "circuito",
      payload: [
        { name: "circuito", value: 1 },
        { name: "filtraInterrupcao", value: 1}
      ],
      title: "TOTAL DE CIRCUITOS",
      value: painelAlarmes.qtd_circuitos,
      textColor: "#DA291C",
      spanColumns: 2,
      spanRows: 2,
      fontSize: "14px",
      numberSize: "52px",
    },
    {
      name: "emAtendimento",
      payload: [{ name: "emAtendimento", value: 1 }],
      title: "EM ATENDIMENTO",
      value: painelAlarmes.qtd_em_andamento,
      textColor: "#00818F",
      spanColumns: 2,
      spanRows: 4,
      fontSize: "14px",
      numberSize: "52px",
    },
    {
      name: "interrompida",
      payload: [
        { name: "flagInterrupcao", value: 1 }
      ],
      title: "INTERROMPIDOS",
      value: painelAlarmes.qtd_interrupcoes,
      textColor: "#FB9C2D",
      spanColumns: 2,
      spanRows: 2,
      fontSize: "14px",
      numberSize: "52px",
    },

    {
      name: "prazo_circuito_sla_07",
      payload: null,
      title: "BLC - 7 DIAS",
      value: painelAlarmes.qtd_prazo_circuito_eh_07,
      textColor: "#555555",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "prazo_circuito_sla_30",
      payload: null,
      title: "DENTRO DA REDE - 30 DIAS",
      value: painelAlarmes.qtd_prazo_circuito_eh_30,
      textColor: "#555555",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },

    {
      name: "classificacao_gross",
      payload: [
        { name: "classificacao_gross", value: 1},
        { name: "filtraInterrupcao", value: 1},
        { name: "statusInterrompida", value: 0},
      ],
      title: "GROSS",
      value: painelAlarmes.qtd_gross,
      textColor: "#DA291C",
      spanColumns: 1,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "classificacao_servico",
      payload:[
        { name: "classificacao_servico", value: 1},
        { name: "filtraInterrupcao", value: 1},
        { name: "statusInterrompida", value: 0},
      ],
      title: "SERVIÇOS",
      value: painelAlarmes.qtd_servicos,
      textColor: "#DA291C",
      spanColumns: 1,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "instalavel",
      payload: [
        { name: "instalavel", value: 1 },
        { name: "flagInterrupcao", value: 1 }
      ],
      title: "INSTALAVEL",
      value: painelAlarmes.qtd_instalavel,
      textColor: "#FB9C2D",
      spanColumns: 1,
      spanRows: 2,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "naoInstalavel",
      payload: [
        { name: "instalavel", value: 0 },
        { name: "flagInterrupcao", value: 1 }
      ],
      title: "NÃO INSTALAVEL",
      value: painelAlarmes.qtd_nao_instalavel,
      textColor: "#FB9C2D",
      spanColumns: 1,
      spanRows: 2,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "prazo_circuito_sla_60",
      payload: null,
      title: "BL TERCEIRO - 60 DIAS",
      value: painelAlarmes.qtd_prazo_circuito_eh_60,
      textColor: "#555555",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },

    {
      name: "classificacao_outros",
      payload: null,
      title: "OUTROS",
      value: painelAlarmes.qtd_outros,
      textColor: "#DA291C",
      spanColumns: 1,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "classificacao_intercompany",
      payload: null,
      title: "INTERCOMPANY",
      value: painelAlarmes.qtd_intercompany,
      textColor: "#DA291C",
      spanColumns: 1,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "prazo_circuito_sla_90",
      payload: null,
      title: "FORA DA REDE - 90 DIAS",
      value: painelAlarmes.qtd_prazo_circuito_eh_90,
      textColor: "#555555",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },

    {
      name: "responsavel_regional",
      payload: [
        { name: 'responsavel_regional', value: 1},
        { name: 'filtraInterrupcao', value: 1}
      ],
      title: "REGIONAL",
      value: painelAlarmes.qtd_responsavel_regional,
      textColor: "#DA291C",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "responsavel_centralizado",
      payload: [
        { name: 'responsavel_centralizado', value: 1},
        { name: 'filtraInterrupcao', value: 1}
      ],
      title: "CENTRALIZADO",
      value: painelAlarmes.qtd_responsavel_centralizado,
      textColor: "#DA291C",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "responsavel_cec",
      payload: [
        { name: "responsavel_cec", value: 1 },
        { name: "flagInterrupcao", value: 1 }
      ],
      title: "CEC",
      value: painelAlarmes.qtd_responsavel_cec,
      textColor: "#DA291C",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
    {
      name: "prazo_circuito_sla_120",
      payload: null,
      title: "TERCEIROS - 120 DIAS",
      value: painelAlarmes.qtd_prazo_circuito_eh_120,
      textColor: "#555555",
      spanColumns: 2,
      spanRows: 1,
      fontSize: "14px",
      numberSize: "24px",
    },
  ];
}

export {
  dadosBoxesPainelAlarmes
}
